export * from './multiple-delayed-action.interface';
export * from './multiple-delayed-action.service';
export * from './multiple-delayed-action.mock';
export const MULTIPLE_DELAYED_ACTION_SERVICE = Symbol('MultipleDelayedActionService');
